import { BorderedBox } from '@/shared/ui/BorderedBox';
import { SectionWrapper } from '@/entities/widget';
import type { CaresAboutSectionProps } from './CaresAboutSection.types';

export const CaresAboutSection = ({ caresAbout, title, icon }: CaresAboutSectionProps) => {
  if (caresAbout.length === 0) {
    return null;
  }

  return (
    <SectionWrapper title={title} icon={icon ?? ''}>
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
        {caresAbout.map((care) => (
          <BorderedBox key={care.title}>
            <div className="flex flex-col gap-2">
              <p className="text-body-md font-medium text-muted-foreground">{care.title}</p>
              <p className="text-body-md text-foreground">{care.description}</p>
            </div>
          </BorderedBox>
        ))}
      </div>
    </SectionWrapper>
  );
};
